import React, { useState } from "react";

const GASSettings = () => {
  const [notificationEnabled, setNotificationEnabled] = useState(true);
  const [defaultView, setDefaultView] = useState("dashboard");

  return (
    <div className="min-h-screen bg-black text-cyan-400 px-4 py-6">
      <h2 className="text-lg font-semibold mb-4">G.A.S. Settings</h2>

      <div className="bg-black/40 p-4 rounded-lg border border-cyan-700 space-y-4">
        {/* Notifications */}
        <div className="flex items-center justify-between">
          <span className="text-sm font-semibold text-gray-300">Enable Notifications</span>
          <input
            type="checkbox"
            checked={notificationEnabled}
            onChange={() => setNotificationEnabled(!notificationEnabled)}
            className="w-5 h-5 accent-cyan-600"
          />
        </div>

        {/* Default View */}
        <div className="flex items-center justify-between">
          <span className="text-sm font-semibold text-gray-300">Default Dashboard View</span>
          <select
            value={defaultView}
            onChange={(e) => setDefaultView(e.target.value)}
            className="bg-black border border-cyan-600 text-cyan-400 px-2 py-1 rounded"
          >
            <option value="dashboard">Dashboard</option>
            <option value="analytics">Analytics</option>
            <option value="appointments">Appointments</option>
          </select>
        </div>

        {/* Placeholder for future settings */}
        <div className="text-sm text-gray-400 italic">
          More settings can be added here (e.g., theme, export preferences, user roles).
        </div>
      </div>
    </div>
  );
};

export default GASSettings;
